import { Ellipsis, Loader2 } from 'lucide-react';
import { TutorAvatar } from './TutorAvatar';

export function BasicLoading() {
  return (
    <div className="my-30 ">
      <div className="centered relative">
        <div className="opacity-50">
          <TutorAvatar noText size={200} />
        </div>
        <Loader2 size={270} className="text-marigold animate-spin absolute" />
      </div>
      <div className="flex justify-center">
        <Ellipsis size={100} className="text-warm-90/30 animate-pulse absolute" />
      </div>
    </div>
  );
}
